import { DSL_API_PATH, DSL_BASE_URL } from '../../constants';
import HttpService from '../http-service/http-service';

export enum EventType {
    EmailClick = 'emailClick',
    TextClick = 'textClick',
}

export default class FeatureGuideService {
    public async callMetrics(fgId: string, eventType: EventType) {
        const getMetricsUrl = `${DSL_BASE_URL +
            DSL_API_PATH.FEATURE_GUIDE_METRICS}?fgId=${fgId}&eventType=${eventType}`;
        try {
            await HttpService.get<void>(getMetricsUrl, false, {
                headers: {
                    ...HttpService.getAppIdRequestHeaders(),
                },
                adapter: 'fetch',
                fetchOptions: { priority: 'low' },
            });
        } catch (e) {
            console.error('callMetrics - ', e);
        }
    }
}

export const featureGuideService = new FeatureGuideService();
